import { render } from "./DefNav.vue?vue&type=template&id=c47c9be2&ts=true"
import script from "./DefNav.vue?vue&type=script&lang=ts"
export * from "./DefNav.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__